module.exports = __webpack_public_path__ + "img/resource-projecto.ed2b2ec4.svg";